import { z } from 'zod';

import { DocumentStatusTypeZod } from './document-status-type';

import { CategoryCodeZod } from 'types/zod/category-code';
import { DocumentTypeCodeZod } from 'types/zod/document-type-code';

export const DocumentZod = z.object({
    document_id: z.number(),
    document_type_code: DocumentTypeCodeZod,
    document_status_code: DocumentStatusTypeZod,
    creation_date: z.number(),
    last_modified_date: z.number(),
    guid: z.string().optional(),
    name: z.string(),
    questionnaire_instance_id: z.number().optional(),
    scan_names: z.array(z.string()).optional(),
    protection: z.any().optional(),
    ownership: z.array(z.number()).optional(),
    category_code: CategoryCodeZod,
});
export type Document = z.infer<typeof DocumentZod>;
